import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=a72bc184&scoped=true&"
import script from "./CodeEditor.vue?vue&type=script&lang=js&"
export * from "./CodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CodeEditor.vue?vue&type=style&index=1&id=a72bc184&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72bc184",
  null
  
)

export default component.exports